import { useEffect, useState } from "react";

export default function CareerV2() {

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    function handleResize() {
        setIsMobile(window.innerWidth <= 768);
    }

    useEffect(() => {
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [])

    return <>
    <style>
    {`
        .rounded-5 {
            border-radius: 3rem;
        }

        .rounded-4 {
            border-radius: 1.5rem;
        }

        .truncate-multiline {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2; /* Number of lines to show */
        }
    `}
    </style>

    <div className="container pt-5">
        <h1>Careers</h1>
    </div>

    <div className="container py-5">
        <div
            className="p-5 rounded-5 row"
            style={{
                backgroundImage: "url('./../img/career-v2/18416.jpg')",
                backgroundPosition: `${isMobile ? 'left' : 'center'} top`,
                backgroundSize: "cover"
            }}
        >
            <div className="col-12">
                <h2 className="mb-3">Care for Your Passion,<br />Grow Your Career</h2>
            </div>
            <div
                className=" col-12 col-sm-4"
                // style={{ width: "33%" }}
            >
                <p>KPJ Healthcare Group is more than just a healthcare provider; we are a trusted partner to our patients and to some of the world's most renowned brands in the hospital and healthcare sectors. Our dynamic workforce of over 17,000 dedicated professionals embodies our commitment to excellence, innovation, and compassionate care. With a network of 29 hospitals across the region, we are at the forefront of healthcare delivery.</p>
                <button
                    onClick={() => { window.location = "https://jcorp.wd102.myworkdayjobs.com/KPJ" }}
                    className="btn rounded-5 px-5 py-2 text-white fw-bold mt-5"
                    style={{
                        backgroundColor: "#003C50"
                    }}
                >
                    Apply Now
                </button>
            </div>
        </div>                 
    </div>

    <div className="py-5">
        <div className="container py-5">
            <div className="d-flex rounded-5 gap-5">
                <div className="w-50 row">
                    <div className="col-12 col-sm-8">
                        <div
                            className="rounded-4 h-100"
                            style={{
                                // width: "66%",
                                backgroundImage: "url('./../img/career-v2/11384.jpg')",
                                backgroundPosition: "center center",
                                backgroundSize: "cover",
                                marginTop: "-3rem",
                                marginBottom: "3rem"
                             }}
                        ></div>
                    </div>
                    <div className="col-12 col-sm-4">
                        <div
                            className="rounded-4 h-100"
                            style={{
                                // width: "33%",
                                backgroundImage: "url('./../img/career-v2/24243.jpg')",
                                backgroundPosition: "center center",
                                backgroundSize: "cover",
                                marginBottom: "-3rem"
                             }}
                        ></div>
                    </div>
                </div>
                <div className="w-50">
                    <h2 className="mb-3">Explore Opportunities within the Group</h2>
                    <p>Our deep commitment to a sustainable future offers both meaningful challenges and opportunities for growth. Whether you are a student, a recent graduate, or a seasoned professional, KPJ Healthcare Group invites you to embark on a rewarding career where your contributions will have a lasting impact on the lives of others.</p>
                </div>
            </div>
        </div>
    </div>

    <div className="container py-5">
        <hr className="m-0" style={{ height: "0.3rem", backgroundColor: "var(--primary-color)", opacity: "1.0" }} />
    </div>

    <div className="container py-5">
        <div className="rounded-5 d-flex flex-column gap-5">
            <div className="text-center">
                <h2 style={{ color: "var(--primary-color)" }}>Find the right opportunity for you!</h2>
                <p>Click on any of the positions below to learn more and connect:</p>
            </div>
            <div className="row gy-3 gy-sm-0 gx-sm-5" style={{ height: `${208 * 3}px` }}>
                <div className="col-12 col-sm-6">
                    <div
                        className="h-100 w-100 rounded-5 p-4 p-sm-5 d-flex align-items-end"
                        style={{
                            backgroundImage: "linear-gradient(transparent, transparent, #39B5B2 75%), url('./../img/career-v2/6141.jpg')",
                            backgroundSize: "cover",
                            backgroundPosition: "center center"
                        }}
                    >
                        <div className="d-flex flex-column" style={{paddingTop: "9rem"}}>
                            <h4 className="text-white fw-bold">Internship</h4>
                            <p className="flex-grow-1 text-white">Are you a passionate and driven student eager to gain hands-on experience in the healthcare industry? Look no further! KPJ Healthcare Berhad is offering an exciting internship opportunity that could be the stepping stone to a bright future.</p>
                            <div>
                                <button className="btn btn-sm btn-outline-light rounded-0" onClick={() => { window.location = "https://jcorp.wd102.myworkdayjobs.com/KPJ/job/INTERNSHIP_JR000000244" }}>Apply Now</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-6">
                    <div
                        className="h-100 w-100 rounded-5 p-4 p-sm-5 d-flex align-items-end"
                        style={{
                                backgroundImage: "linear-gradient(transparent, transparent, #003C50 75%), url('./../img/career-v2/56642.jpg')",
                                backgroundSize: "cover",
                                backgroundPosition: "center center",
                        }}
                    >
                        <div className="d-flex flex-column" style={{paddingTop: "9rem"}}>
                            <h4 className="text-white fw-bold">Head Office, Hospitals & Subsidiaries</h4>
                            <p className="flex-grow-1 text-white">Join our dynamic and dedicated teams at KPJ Healthcare Berhad, where you'll have the opportunity to contribute to exceptional healthcare services across our hospitals and subsidiaries throughout Malaysia.</p>
                            <div>
                                <button className="btn btn-sm btn-outline-light rounded-0" onClick={() => { window.location = "https://jcorp.wd102.myworkdayjobs.com/KPJ" }}>Apply Now</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div
        style={{
            backgroundImage: "url('./../img/career-v2/33538.png')",
            backgroundSize: "cover",
        }}
    >
        <div className="pb-5" style={{ backgroundColor: "rgba(255,255,255,0.95)" }}>
            <div className="container py-5">
                <div className="rounded-5">
                    <div className="text-center mb-0 mb-sm-5 pb-0 pb-sm-5">
                        <p style={{ color: "#003C50" }}>Our Commitment to</p>
                        <h1 className="" style={{ color: "var(--primary-color" }}>Care For Life</h1>
                        <p className="text-center">
                            For over 40 years, we have delivered exceptional, compassionate, and personalised care. Today, our commitment to Care for Life grows stronger, reaching new heights for our <span className="fw-bold" style={{ color: "#003C50" }}>Patients</span>, <span className="fw-bold" style={{ color: "#361A50" }}>People</span>, <span className="fw-bold" style={{ color: "#FBB01C" }}>Partners</span>, <span className="fw-bold" style={{ color: "#38B3B1" }}>Physicians</span>, and <span className="fw-bold" style={{ color: "#EF6661" }}>Planet</span>.
                        </p>
                    </div>
                    <img src="./../img/career-v2/5P.png" alt="" className="w-100" />
                </div>
            </div>
        </div>
    </div>

    <div
        className="py-5"
        style={{ backgroundImage: "linear-gradient(90deg, #000000 0%, #003C50 100%)" }}
    >
        <div className="container py-5 gap-5">
            <div className="row">
                <div className="col-12 col-sm-6 pb-5 pb-sm-0">
                    <p className="text-white fs-4 lh-sm">
                        <strong>KPJ Healthcare Berhad is the leading provider of private healthcare services in Malaysia</strong>, with a history dating back to 1981 when it introduced the first private specialist hospital in Johor.
                    </p>
                    <p className="text-white">
                        The Group’s shared values, represented by the acronym <strong>C.A.R.E: Committed, Accountable, Respectful, and Excellent</strong>, drives its integrated network of 29 specialist hospitals across Malaysia.
                    </p>
                    <div className="mt-5">
                            <button className="btn text-white p-0" onClick={() => { window.location = "https://kpj.listedcompany.com/profile.html" }}>Learn More About KPJ Healthcare's History&nbsp;&nbsp;&nbsp;&#10230;
                        </button>
                    </div>
                </div>
                <div className="col-12 col-sm-6">
                    <div className="d-flex flex-column text-center gap-3 h-100">
                        <div className="d-flex h-50 gap-3">
                            <div className="w-50 d-flex flex-column gap-3">
                                <div className="flex-grow-1" style={{
                                    backgroundColor: "#FBB01C",
                                    maskImage: "url('./../img/career-v2/icon-committed.svg')",
                                    maskRepeat: "no-repeat",
                                    maskPosition: "center center",
                                    height: isMobile ? '74px' : undefined
                                 }}></div>
                                <h2 className="text-white text-uppercase"><span style={{ color: "#FBB01C" }}>C</span>ommitted</h2>
                            </div>
                            <div className="w-50 d-flex flex-column gap-3">
                                <div className="flex-grow-1" style={{
                                    backgroundColor: "#38B3B1",
                                    maskImage: "url('./../img/career-v2/icon-accountable.svg')",
                                    maskRepeat: "no-repeat",
                                    maskPosition: "center center",
                                    height: isMobile ? '74px' : undefined
                                 }}></div>
                                <h2 className="text-white text-uppercase"><span style={{ color: "#38B3B1" }}>A</span>ccountable</h2>
                            </div>
                        </div>
                        <div className="d-flex h-50 gap-3">
                            <div className="w-50 d-flex flex-column gap-3">
                                <div className="flex-grow-1" style={{
                                    backgroundColor: "#EF6661",
                                    maskImage: "url('./../img/career-v2/icon-respectful.svg')",
                                    maskRepeat: "no-repeat",
                                    maskPosition: "center center",
                                    height: isMobile ? '74px' : undefined
                                 }}></div>
                                <h2 className="text-white text-uppercase"><span style={{ color: "#EF6661" }}>R</span>espectful</h2>
                            </div>
                            <div className="w-50 d-flex flex-column gap-3">
                                <div className="flex-grow-1" style={{
                                    backgroundColor: "var(--primary-color)",
                                    maskImage: "url('./../img/career-v2/icon-excellent.svg')",
                                    maskRepeat: "no-repeat",
                                    maskPosition: "center center",
                                    height: isMobile ? '74px' : undefined
                                 }}></div>
                                <h2 className="text-white text-uppercase"><span style={{ color: "var(--primary-color)" }}>E</span>xcellent</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div className="py-5 overflow-auto">
        <div className="container py-5 d-flex flex-column gap-5 justify-content-center align-items-center">
            <div className="d-flex gap-5">
                <h2>Awards</h2>
                <p>At KPJ Healthcare, we are dedicated to fostering a positive and supportive workplace culture. Our efforts to create an environment where employees thrive have been recognised through prestigious industry award.</p>
            </div>
            <div className="d-flex flex-column flex-sm-row gap-5 justify-content-center gap-5 py-5 my-5 w-75">
                <div className="p-5 d-flex position-relative"
                    style={{ 
                        backgroundColor: "#38B3B1",
                        // width: "33%"
                    }}
                >
                    <img src="./../img/career-v2/1.png" alt="" className="position-absolute"
                        style={{
                            height: "150%",
                            top: "-25%",
                            left: "-12.5%",
                            zIndex: "2"
                        }}
                    />
                    <div className="ps-5 d-flex flex-column position-relative" style={{ zIndex: "2" }}>
                        <h3 className="text-white">TALENTBANK Graduates Choice of Employer Award</h3>
                        <hr className="" style={{ height: "3px", backgroundColor: "#003C50", borderColor: "#003C50", opacity: "1.0" }} />
                        <p className="text-white">Champion in Healthcare 2024 (Hospital)</p>
                    </div>
                    <div className="position-absolute p-5 rounded-5"
                        style={{ 
                            right: 0,
                            top: 0,
                            zIndex: "1",
                            backgroundColor: "#38B3B1"
                        }}
                    >
                    </div>
                    <div className="position-absolute p-5 rounded-5"
                        style={{ 
                            right: 0,
                            top: "6rem",
                            zIndex: "1",
                            backgroundColor: "#38B3B1"
                        }}
                    >
                    </div>
                    <div className="position-absolute bg-white"
                        style={{ 
                            right: 0,
                            top: "3rem",
                            zIndex: "0",
                            height: "6rem",
                            width: "3rem"
                        }}
                    >
                    </div>
                </div>
                <div className="p-5"></div>
                <div className="p-5 d-flex position-relative"
                    style={{ 
                        backgroundColor: "#38B3B1",
                        // width: "33%"
                    }}
                >
                    <img src="./../img/career-v2/2.png" alt="" className="position-absolute"
                        style={{
                            height: "150%",
                            top: "-25%",
                            left: "-12.5%",
                            zIndex: "2"
                        }}
                    />
                    <div className="ps-5 d-flex flex-column position-relative" style={{ zIndex: "2" }}>
                        <h3 className="text-white">SEEK People & Purpose Awards 2024 (Platinum)</h3>
                        <hr className="" style={{ height: "3px", backgroundColor: "#003C50", borderColor: "#003C50", opacity: "1.0" }} />
                        <p className="text-white">Top Voted Employer in the Healthcare & Pharmaceutical Industry</p>
                    </div>
                    <div className="position-absolute p-5 rounded-5"
                        style={{ 
                            right: 0,
                            top: 0,
                            zIndex: "1",
                            backgroundColor: "#38B3B1"
                        }}
                    >
                    </div>
                    <div className="position-absolute p-5 rounded-5"
                        style={{ 
                            right: 0,
                            top: "6rem",
                            zIndex: "1",
                            backgroundColor: "#38B3B1"
                        }}
                    >
                    </div>
                    <div className="position-absolute bg-white"
                        style={{ 
                            right: 0,
                            top: "3rem",
                            zIndex: "0",
                            height: "6rem",
                            width: "3rem"
                        }}
                    >
                    </div>
                </div>
            </div>
            <p className="text-center fw-bold">Join a dynamic team dedicated to advancing healthcare, where your skills and passion can truly make a difference. Explore our available positions and take the next step in your career today!</p>
            <div className="d-flex justify-content-center">
                <button
                    onClick={() => { window.location = "https://jcorp.wd102.myworkdayjobs.com/KPJ" }}
                    className="btn rounded-5 px-5 py-2 text-white fw-bold"
                    style={{
                        backgroundColor: "#003C50"
                    }}
                >
                    Apply Now
                </button>
            </div>
        </div>
    </div>
    </>;
}